export default "__VITE_ASSET__BCJUgJQz__"